enum FileTypes {
  JSON = "JSON",
  ZIP = "ZIP"
}

export default FileTypes